import client from '../helpers/HttpClient';
import handleError from '../helpers/error';

class UserService {
  transformRequest = (jsonData = {}) =>
    Object.entries(jsonData)
      .map(x => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`)
      .join('&');

  async login(email, password) {
    try {
      const result = await client.post(
        '/login',
        this.transformRequest({username: email, password: password, grant_type: 'password'}),
        { headers: {'Content-Type': 'application/x-www-form-urlencoded' }}
      );

      if (!result.data) {
        throw new Error("Falha no Login");
      } else {
        // Store token
        localStorage.setItem('token', JSON.stringify(result.data));
        return result?.data;
      }
    } catch (error) {
      let msg;
      if (!error.response) {
        msg = "Erro ao conectar no servidor."
      } else if (error.response.status == 400) {
        msg = "Usuário ou senha incorreto";
      } else if (error.response.status == 402) {
        msg = "Licença expirada ou limite de usuários atingido. Entre em contato com o suporte";
      } else {
        msg = "Ocorreu um erro, por favor tente novamente mais tarde";
      }
      return Promise.reject(msg);
    }
  }

  async me() {
    try {
      const result = await client.get('/user/me');

      if (!result || !result.data) {
        throw new Error("Erro ao buscar dados do usuário");
      } else {
        const user = result.data;
        const permissions = {
          1: [
            "home",
            "request.fetch", "request.create", "request.update", "request.remove", "request.get",
            "user.fetch", "user.create", "user.update", "user.remove", "user.get",
            "ldap.fetch", "ldap.create", "ldap.update", "ldap.remove", "ldap.get",
            "group.fetch", "report.fetch", "clock.fetch",
            "mail.edit", "user.unlock", "delegation.fetch", "delegation.create"
          ],
          2: ["home", "request.fetch", "request.create", "request.update", "request.remove", "request.get","access.fetch"],
          3: ["home", "request.fetch", "request.create", "request.update", "request.remove", "request.get"],
          4: ["home", "request.fetch", "request.create", "request.update", "request.remove", "request.get", "clock.fetch", "report.fetch", "access.fetch"],
          5: ["home", "request.fetch", "request.create", "user.fetch", "clock.fetch", "user.unlock", "user.update", "user.create"],
          6: ["home", "request.fetch", "user.fetch", "clock.fetch", "report.fetch"],
        };
        user.permissions = permissions[user.Role];

        localStorage.setItem('me', JSON.stringify(user));
        return result?.data;
      }
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async status(username) {
    try {
      const result = await client.get(`/user/status`);        
      return result?.data;      
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetch(params) {
    try {
      const result = await client.get('user/index', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchManagers(params) {
    try {
      const result = await client.get('user/managers', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async subordinates(params) {
    try {
      const result = await client.get('user/subordinates', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async create(obj) {
    try {
      const result = await client.post('user/create', obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async update(id, obj) {
    try {
      const result = await client.post(`user/update/${id}`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async get(id) {
    try {
      const result = await client.get(`user/view/${id}`);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async remove(id) {
    try {
      const result = await client.post(`user/delete/${id}`);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async unblock(id) {
    try {
      const result = await client.post(`user/unblock/${id}`);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async unblockAll(id) {
    try {
      const result = await client.post(`user/unblockAll`);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchGroups(params) {
    try {
      const result = await client.get('usergroup/index', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async createGroup(obj) {
    try {
      const result = await client.post('usergroup/create', obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async updateGroup(id, obj) {
    try {
      const result = await client.post(`usergroup/update/${id}`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async getGroup(id) {
    try {
      const result = await client.get(`usergroup/view/${id}`);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncGroupAzureAd(id) {
    try {
      const result = await client.post(`usergroup/syncazuread/${id}`);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncGroupAd(id) {
    try {
      const result = await client.post(`usergroup/syncad/${id}`);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async removeGroup(id) {
    try {
      const result = await client.post(`usergroup/delete/${id}`);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async importUsers(file) {
    try {
      const url = 'importar-usuarios';
      const formData = new FormData();
      formData.append('file',file)
      const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
      };
      const result = await client.post(url, formData, config);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async importBlock(file) {
    try {
      const url = 'importar-bloqueio';
      const formData = new FormData();
      formData.append('file',file)
      const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
      };
      const result = await client.post(url, formData, config);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async importExternalId(file) {
    try {
      const url = 'importar-alias';
      const formData = new FormData();
      formData.append('file',file)
      const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
      };
      const result = await client.post(url, formData, config);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async importGroup(file) {
    try {
      const url = 'importar-grupos';
      const formData = new FormData();
      formData.append('file',file)
      const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
      };
      const result = await client.post(url, formData, config);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }
}

export default new UserService();
